export default 'https://tme.understood.org/assets/headphones.50b18d89.glb'